import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import R from 'ramda';

import CardsGridWrapper from '../../../CardsGridWrapper';
import CardsOverlayOneThirdMarkup from '../CardsOverlayOneThirdMarkup';
import CardElement from '../../../CardElement';

const isCardHighlighted = index => index === 1;
// ! TODO: [1] Write test as some parts are shared with CardsOverlayBackgroundVerticalOneThird
const generateCardClassNames = ({ index }) => classNames(
  'card',
  'cell',
  'card--overlay-bottom-1of3', {
    'xsmall-16 medium-6 card--overlay-highlighted': isCardHighlighted(index),
    'xsmall-8 medium-5 card--overlay-highlighted-sibling-offset-1of3': !isCardHighlighted(index),
  },
);

const generateCardContentBoxClassNames = ({ contentBoxTheme }) => classNames(
  'xsmall-text--center',
  {
    'card__content-box--solid': contentBoxTheme === 'solid',
    'card__content-box--alpha': contentBoxTheme === 'alpha',
  },
);

const CardsOverlayHighlightVerticalOneThird = ({
  fullWidth = false,
  isTitleUnderlined = true,
  contentBoxTheme = 'solid',
  headingLevel,
  cardsData,
  zoomOnHover,
  fixedHeight,
  hideDescription,
  openLinkInNewTab = false,
  fullClickableArea = true,
}) => (
  <CardsGridWrapper fullWidth={fullWidth}>
    {Array.isArray(cardsData) && (
      cardsData.map(({ contentBoxAlignment, ...card }, index) => (
        <div key={R.prop('id')(card)} className={generateCardClassNames({ index })}>
          <CardElement
            linkUrl={R.path(['link', 'url'])(card)}
            linkText={R.path(['link', 'text'])(card)}
            accessibleLinkText={R.path(['link', 'accessibleText'])(card)}
            openLinkInNewTab={openLinkInNewTab}
            fullClickableArea={fullClickableArea}
          >
            <CardsOverlayOneThirdMarkup
              description={R.prop('description')(card)}
              imageSrc={R.prop('imageSrc')(card)}
              srcset={R.prop('imageSrcSet')(card)}
              alt={R.prop('alt')(card)}
              link={R.prop('link')(card)}
              title={R.prop('title')(card)}
              contentBoxAlignment={contentBoxAlignment}
              isTitleUnderlined={isTitleUnderlined}
              headingLevel={headingLevel}
              extraCardContentBoxClassNames={generateCardContentBoxClassNames({ contentBoxTheme })}
              zoomOnHover={zoomOnHover}
              fixedHeight={fixedHeight}
              hideDescription={hideDescription}
              openLinkInNewTab={openLinkInNewTab}
              fullClickableArea={fullClickableArea}
            />
          </CardElement>
        </div>
      ))
    )}
  </CardsGridWrapper>
);

CardsOverlayHighlightVerticalOneThird.propTypes = {
  fullWidth: PropTypes.bool,
  isTitleUnderlined: PropTypes.bool,
  headingLevel: PropTypes.number,
  contentBoxTheme: PropTypes.oneOf(['solid', 'alpha']),
  cardsData: PropTypes.arrayOf(PropTypes.shape({
    contentBoxAlignment: PropTypes.oneOf(['bottom']),
    description: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    link: PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string,
    }),
  })),
  zoomOnHover: PropTypes.bool,
  fixedHeight: PropTypes.bool,
  hideDescription: PropTypes.bool,
  openLinkInNewTab: PropTypes.bool,
  fullClickableArea: PropTypes.bool,
};

export default CardsOverlayHighlightVerticalOneThird;
